import { render, staticRenderFns } from "./franchisee-change.vue?vue&type=template&id=513fbf35&scoped=true&"
import script from "./franchisee-change.vue?vue&type=script&lang=js&"
export * from "./franchisee-change.vue?vue&type=script&lang=js&"
import style0 from "./franchisee-change.vue?vue&type=style&index=0&id=513fbf35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513fbf35",
  null
  
)

export default component.exports